import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, AlertTriangle } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Button } from '../components/ui/Button';
export function HelpGoogleSheetsPage() {
  return <div className="min-h-screen bg-gray-50" dir="rtl" data-id="element-1249">
      <Navbar data-id="element-1250" />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1251">
        <Link to="/configure" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-1252">
          <ArrowRight className="ml-2 w-4 h-4" data-id="element-1253" />
          رجوع إلى الإعدادات
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-1254">
          <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-1255">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1256">
              كيفية ربط Google Sheets
            </h1>
            <p className="text-gray-600" data-id="element-1257">
              اتبع الخطوات التالية للحصول على Client ID و Client Secret من
              Google Cloud Console
            </p>
          </div>

          <div className="p-8 space-y-8" data-id="element-1258">
            {/* Warning */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex items-start gap-3" data-id="element-1259">
              <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-1260" />
              <div className="text-sm text-yellow-800" data-id="element-1261">
                <strong data-id="element-1262">تحذير أمني:</strong> لا تشارك Client Secret مع أي شخص.
                احتفظ به في مكان آمن.
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-6" data-id="element-1263">
              <div className="flex gap-4" data-id="element-1264">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1265">
                  1
                </div>
                <div className="flex-1" data-id="element-1266">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1267">
                    افتح Google Cloud Console
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1268">
                    انتقل إلى{' '}
                    <a href="https://console.cloud.google.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline inline-flex items-center gap-1" data-id="element-1269">
                      Google Cloud Console
                      <ExternalLink size={14} data-id="element-1270" />
                    </a>
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1271">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1272">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1273">
                  2
                </div>
                <div className="flex-1" data-id="element-1274">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1275">
                    أنشئ مشروع جديد أو اختر مشروع موجود
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1276">
                    من القائمة العلوية، اضغط على اسم المشروع واختر "New Project"
                    أو اختر مشروعاً موجوداً.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1277">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1278">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1279">
                  3
                </div>
                <div className="flex-1" data-id="element-1280">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1281">
                    فعّل Google Sheets API
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1282">
                    اذهب إلى "APIs & Services" → "Enable APIs and Services" →
                    ابحث عن "Google Sheets API" وفعّله.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1283">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1284">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1285">
                  4
                </div>
                <div className="flex-1" data-id="element-1286">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1287">
                    أنشئ OAuth 2.0 Credentials
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1288">
                    اذهب إلى "Credentials" → "Create Credentials" → "OAuth
                    client ID"
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-1 mb-3" data-id="element-1289">
                    <li data-id="element-1290">Application type: Web application</li>
                    <li data-id="element-1291">Name: Operiens Integration</li>
                    <li data-id="element-1292">
                      Authorized redirect URIs: أضف الرابط من صفحة الإعدادات
                    </li>
                  </ul>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1293">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1294">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-1295">
                  5
                </div>
                <div className="flex-1" data-id="element-1296">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1297">
                    انسخ Client ID و Client Secret
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1298">
                    بعد إنشاء الـ OAuth client، ستظهر لك نافذة تحتوي على Client
                    ID و Client Secret. انسخهما والصقهما في صفحة الإعدادات.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1299">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>
            </div>

            {/* Video Tutorial */}
            <div className="border-t border-gray-100 pt-8" data-id="element-1300">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-1301">شرح بالفيديو</h3>
              <div className="bg-gray-100 rounded-lg aspect-video flex items-center justify-center text-gray-500" data-id="element-1302">
                [فيديو يوتيوب - سيتم إضافته]
              </div>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-100 pt-8" data-id="element-1303">
              <Link to="/configure" data-id="element-1304">
                <Button size="lg" fullWidth data-id="element-1305">
                  رجوع إلى الإعدادات
                  <ArrowRight className="mr-2 w-5 h-5" data-id="element-1306" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>;
}